import { makeEnvironmentProviders } from '@angular/core';
import { IntelligenceApiConfig } from '@mri-platform/dsg/core';
import { AUTHENTICATED_API_URL } from '@mri-platform/shared/app-core-integration';
import { Settings } from '@mri-platform/shared/core';

export function provideIntelligenceApiConfig() {
  return makeEnvironmentProviders([
    {
      provide: IntelligenceApiConfig,
      useFactory: (settings: Settings) => new IntelligenceApiConfig(settings.intelligenceApi),
      deps: [Settings]
    },
    {
      provide: AUTHENTICATED_API_URL,
      useFactory: (config: IntelligenceApiConfig) => config.baseUrl,
      deps: [IntelligenceApiConfig],
      multi: true
    }
  ]);
}
